module.exports = __webpack_public_path__ + "static/assets/a301f197f062c39598b5b102aebfc8ef.svg";